<div class="login-page">
  <!-- Left: form -->
  <div class="login-panel">
    <div class="login-panel-inner">
      <div class="login-logo">
        <img alt="Snöball" src="../../../assets/images/blue-logo.png" />
      </div>

      <h1 class="login-welcome">{{ 'Loginpage.welcome_back' | translate }}</h1>

      @if (submitted && !authMessage['Success'] && authMessage['msg']) {
      <div
        class="login-alert login-alert--error"
        role="alert"
      >
        <p>{{ authMessage['msg'] }}</p>
      </div>
      }

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <label class="login-field-label" for="temporary-email">{{ 'Loginpage.email' | translate }}</label>
        <input
          id="temporary-email"
          class="login-input"
          [class.login-input--invalid]="submitted && f.email.errors"
          formControlName="email"
          [placeholder]="'Loginpage.email_placeholder' | translate"
          type="email"
          autocomplete="username"
          required="required"
        />
        @if (submitted && f.email.errors) {
        <div class="login-field-error">
          @if (f.email.errors.required) {
          <span>{{ 'Loginpage.email_require' | translate }}</span>
          }
          @if (f.email.errors.email) {
          <span>{{ 'Loginpage.valid_email' | translate }}</span>
          }
        </div>
        }

        <label class="login-field-label" for="temporary-password">{{ 'Loginpage.temporary_password' | translate }}</label>
        <input
          id="temporary-password"
          class="login-input"
          [class.login-input--invalid]="submitted && f.password.errors"
          formControlName="password"
          [placeholder]="'Loginpage.password_placeholder' | translate"
          type="password"
          autocomplete="current-password"
          required="required"
        />
        @if (submitted && f.password.errors) {
        <div class="login-field-error">
          @if (f.password.errors.required) {
          <span>{{ 'Loginpage.password_require' | translate }}</span>
          }
          @if (f.password.errors.minlength) {
          <span>{{ 'Loginpage.valid_password' | translate }}</span>
          }
        </div>
        }

        <button class="login-submit mt-3" type="submit" [disabled]="loginPending()"
                [attr.aria-busy]="loginPending()">
          @if (loginPending()) {
          <i class="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
          }
          @if (loginPending()) {
          <span>{{ 'Loginpage.logging_in' | translate }}</span>
          }
          @if (!loginPending()) {
          <span>{{ 'Loginpage.login' | translate }}</span>
          }
        </button>
      </form>

      <p class="login-footer-cta">
        <a class="login-forgot" routerLink="/login">
          <span aria-hidden="true">←</span> {{ 'Loginpage.back_to_signin' | translate }}
        </a>
      </p>
    </div>
  </div>

  <!-- Right: marketing (desktop) -->
  <app-auth-marketing-panel></app-auth-marketing-panel>
</div>
